import { apiSlice } from "../Slices/apiSlice";


export const brPrivService = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getAllMappings: builder.query({
            query: () => "/br-management/managed-br/privileges/roles",
            providesTags: ['brPriv']
        }),

        getMappingById: builder.query({
            query: (id) => `/br-management/managed-br/privileges/${id}`,
            providesTags: ['brPriv']
        }),

        createMapping: builder.mutation({
            query: (details) => ({
                url: '/br-management/managed-br/privileges',
                method: 'POST',
                body: details
            }),
            invalidatesTags: ['brPriv']
        }),

        // updateMapping: builder.mutation({
        //     query: (details) => ({
        //         url: '',
        //         method: 'PUT',
        //         body: details
        //     }),
        //     invalidatesTags: ['brPriv']
        // }),

        deleteMapping: builder.mutation({
          query: (id) => ({
                url: `/br-management/managed-br/privileges/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["brPriv"],
        }),

    })
});

export const {
    useGetAllMappingsQuery,
    useGetMappingByIdQuery,
    useCreateMappingMutation,
    useUpdateMappingMutation,
    useDeleteMappingMutation,
} = brPrivService;